import SellsReport from "./SellsReport";

export default SellsReport;
